export const getFilename = (filenameWithExtension: string): string => {
  // Check if there is a dot in the filename that's not at the beginning
  const lastIndex = filenameWithExtension.lastIndexOf(".");
  if (lastIndex > 0) {
    // Return the part of the filename before the last dot
    return filenameWithExtension.substring(0, lastIndex);
  }
  // Return the original filename if no extension is found or the dot is at the beginning
  return filenameWithExtension;
};
